<template>
  <div>

    <div class="flex flex-wrap items-center">
      <!-- ITEMS PER PAGE -->
      <div class="flex-grow">
        <div class="vx-row">
          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
            <statistics-card-line hideChart class="mb-base" icon="PlusCircleIcon" icon-right
              :statistic="currency(deposit)" statisticTitle="DEPOSIT BALANCE" color="warning" />
          </div>

          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
            <statistics-card-line hideChart class="mb-base" icon="MinusCircleIcon" icon-right
              :statistic="currency(withdraw)" statisticTitle="WITHDRAW BALANCE" color="danger" />
          </div>
        </div>

      </div>
    </div>
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          {{ checkusebank }}
          <!-- COMPUTED STORE CHECK USE BANK  DO NOT DELETE BY LILSHARK-->
          <div class="vx-card__title">
            <h1>รายการฝาก {{ payment_code }}</h1>
            <br />
          </div>
          <flat-pickr v-model="date" />
          <p class="mt-4">Selected Date: {{ date }}</p>
        </div>
      </div>
      <vs-table stripe max-items="20" pagination :data="memberData" search>
        <template slot="header">
          <vs-button
              :disabled="!$store.state.AppActiveUser.permissions.payment.action"
              color="primary"
              type="filled"
              class="mb-2"
              @click="popup_qr = true"
              icon-pack="feather"
              icon="icon-plus"
            >
              สร้างรายการฝาก
            </vs-button>  
        </template>
        <template slot="thead">
          <vs-th>วัน/เวลา</vs-th>
          <vs-th>ช่องทาง</vs-th>
          <vs-th>ยอดเงิน</vs-th>
          <vs-th>ORDER ID</vs-th>
          <vs-th>USERNAME</vs-th>
          <vs-th>สถานะการทำรายการ</vs-th>
          <vs-th>สถานะแอดเครดิต</vs-th>
          <vs-th>จัดการ</vs-th>
          <vs-th></vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.datetime">
              {{ moment(tr.datetime).format("YYYY-MM-DD HH:mm:ss") }}
            </vs-td>

            <vs-td :data="tr.trans_type">
              {{ payment_code }}
            </vs-td>
            <vs-td :data="tr.amount">
              {{ currency(tr.amount) }}
              <div v-if="tr.amount_usdt" class="text-xs text-grey">
                {{ tr.amount_usdt }} {{ tr.currency }} · {{ tr.chain }}
              </div>
            </vs-td>
            <vs-td :data="order_ref(data[indextr])">
              {{ order_ref(data[indextr]) }}
            </vs-td>
            <vs-td class="text-danger"><router-link :to="`/member/${data[indextr].username}`">{{
              data[indextr].username
                }}</router-link>
            </vs-td>
            <!-- Status -->
            <vs-td :class="data[indextr].status == 1
              ? 'text-success'
              : data[indextr].status == 2 || data[indextr].status == 3
                ? 'text-warning'
                : data[indextr].status == 4
                  ? 'text-danger'
                  : null
              ">
              {{ check_status(data[indextr].status) }}
            </vs-td>
            <vs-td :class="data[indextr].status_addcredit == 1
              ? 'text-success'
              : data[indextr].status_addcredit == 2 ||
                data[indextr].status_addcredit == 3
                ? 'text-warning'
                : data[indextr].status_addcredit == 98 ||
                  data[indextr].status_addcredit == 4
                  ? 'text-danger'
                  : null
              ">
              {{ check_status_addcredit(data[indextr].status_addcredit) }}
            </vs-td>

            <!-- Status END -->
            <!-- button -->
            <vs-td v-if="data[indextr].status_addcredit == 0 &&
              profile.bank_show == 0 &&
              data[indextr].status == 1
            "><vs-button :disabled="$store.state.AppActiveUser.permissions.payment.action
              ? false
              : true
              " size="small" color="success" type="border" text-color="white" icon="description"
                @click="input_username(tr.order_id, tr.amount)">กำลังรอทำรายการ
              </vs-button></vs-td>
            <vs-td v-else-if="data[indextr].status_addcredit >= 2 && data[indextr].status_addcredit <= 8 && data[indextr].status == 1">
              <vs-button :disabled="$store.state.AppActiveUser.permissions.payment.action
                ? false
                : true
                " size="small" color="success" type="filled" icon="description"
                @click="input_username(tr.order_id, tr.amount)">ยังไม่ใช้งาน
              </vs-button></vs-td>
            <vs-td v-else></vs-td>
            <vs-td v-if="data[indextr].status_addcredit == 0 && profile.bank_show == 0
            "><vs-button :disabled="$store.state.AppActiveUser.permissions.payment.action
              ? false
              : true
              " size="small" color="danger" type="border" icon="description"
                @click="input_cancel(tr.order_id, tr.amount)">ยกเลิก
              </vs-button></vs-td>
            <vs-td v-else-if="data[indextr].status_addcredit == 2"><vs-button :disabled="$store.state.AppActiveUser.permissions.payment.action
              ? false
              : true
              " size="small" color="danger" type="filled" icon="description"
                @click="input_cancel(tr.order_id, tr.amount)">ยกเลิก
              </vs-button></vs-td>
            <vs-td v-else-if="data[indextr].status_addcredit == 3"><vs-button :disabled="$store.state.AppActiveUser.permissions.payment.action
              ? false
              : true
              " size="small" color="danger" type="filled" icon="description"
                @click="input_cancel(tr.order_id, tr.amount)">ยกเลิก
              </vs-button></vs-td>
            <vs-td v-else-if="data[indextr].status_addcredit == 4"><vs-button :disabled="$store.state.AppActiveUser.permissions.payment.action
              ? false
              : true
              " size="small" color="danger" type="filled" icon="description"
                @click="input_cancel(tr.order_id, tr.amount)">ยกเลิก
              </vs-button></vs-td>
            <vs-td v-else-if="data[indextr].status_addcredit != 1 && data[indextr].status != 3 && data[indextr].status_addcredit != 98">
              <vs-row>
                <vs-button :disabled="$store.state.AppActiveUser.permissions.payment.action
                  ? false
                  : true
                  " size="small" color="success" type="filled" icon="description"
                  @click="input_username(tr.order_id, tr.amount)">ใช้ยอด
                </vs-button>
                <vs-button :disabled="$store.state.AppActiveUser.permissions.payment.action
                  ? false
                  : true
                  " size="small" color="danger" type="filled" icon="description" class="mx-2"
                  @click="input_cancel(tr.order_id, tr.amount)">ยกเลิก
                </vs-button>
              </vs-row>

            </vs-td>

            <vs-td v-else />
            <!-- button end-->
          </vs-tr>

        </template>
      </vs-table>
    </div>
    <!-- popup_usebank -->
    <vs-popup classContent="popup-example" title="Username" :active.sync="popup_usebank">
      <br />
      <vx-input-group class="mb-base">
        <template slot="prepend">
          <div class="prepend-text bg-primary">
            <span>Username</span>
          </div>
        </template>
        <vs-input placeholder="Username" v-model="username" />
      </vx-input-group>
      <div class="mt-2">
        <vs-input class="inputx" placeholder="กรุณาวางรูป" :value="selectedFile.name" @paste="onPaste" />
        <vs-checkbox disabled="true" class="mt-2" :color="chk_box.color" v-model="chk_box.data">{{ chk_box.text
          }}</vs-checkbox>
        <canvas style="border:1px solid grey;" id="mycanvas" width="100" height="100"></canvas>
      </div>
      <br />
      <p v-if="this.username === ''">
        <small class="text-danger">- กรุณาใส่ Username ก่อนกดปุ่ม OK</small>
      </p>
      <p v-else><small class="text-success">- ใส่ Username สำเร็จ </small></p>

      <vs-button @click="use_bank(order_id, amount)" color="primary" type="filled" class="mt-2"
        :disabled="!username">OK</vs-button>
    </vs-popup>
    <!-- popup_cancel -->
    <vs-popup classContent="popup-example" title="Username" :active.sync="popup_cancel">
      <br />
      <h3 class="text-center">
        ยกเลิกยอดฝาก <br />
        จำนวนเงิน {{ amount }}
      </h3>
      <br />
      <vs-button @click="use_cancel(order_id, amount)" color="primary" type="filled">ยืนยัน</vs-button>
    </vs-popup>
    <!-- popup_qr -->
    <vs-popup classContent="popup-example" :title="is_crypto ? 'สร้างรายการฝาก crypto' : 'สร้าง QR ฝากเงิน'" :active.sync="popup_qr">
      <div>
        <vs-input class="w-full mt-2" label="username" v-model="qr_username" type="text" name="username" />
        <template v-if="is_crypto">
          <vs-select class="w-full mt-2" label="เหรียญ / เครือข่าย" v-model="qr_currency_id" placeholder="เลือกให้ตรงกับเครือข่ายที่ลูกค้าจะโอน">
            <vs-select-item v-for="coin in coins" :key="coin.id" :value="coin.id" :text="`${coin.text} · เรท ${coin.thb_rate} บาท`" />
          </vs-select>
          <vs-input class="w-full mt-2" :label="`จำนวน ${selectedCoin ? selectedCoin.coin : 'เหรียญ'}`" v-model="qr_crypto_amount" type="number" name="crypto_amount" />
          <p v-if="cryptoTHB" class="mt-2 text-sm">
            ≈ {{ currency(cryptoTHB) }} บาท (ค่ายอาจบวกค่าธรรมเนียม ยอดที่ต้องโอนจริงจะแสดงหลังสร้างรายการ)
          </p>
          <p v-if="!coins.length" class="mt-2 text-sm text-danger">
            ยังไม่มีเหรียญที่เปิดใช้งาน — ตั้งค่าที่เมนู ระบบ Crypto Rate
          </p>
        </template>
        <vs-input v-else class="w-full mt-2" label="จำนวนเงิน" v-model="qr_amount" type="number" name="amount" />
        <div class="mt-4 flex">
          <vs-button
            :disabled="!$store.state.AppActiveUser.permissions.payment.action"
            color="primary"
            type="filled"
            @click="generateQR('qr')"
          >
            {{ is_crypto ? (qr_result ? 'สร้างรายการ crypto ใหม่' : 'สร้างรายการ crypto') : (qr_result ? 'สร้าง QR ใหม่' : 'สร้าง QR') }}
          </vs-button>
        </div>
        <div v-if="qr_result" class="mt-4">
          <vs-divider />
          <vs-input class="w-full mt-2" label="username" v-model="qr_result.data.username" type="text" readonly />
          <vs-input class="w-full mt-2" label="จำนวนเงิน" v-model="qr_result.data.amount" type="number" readonly />
          <vs-input class="w-full mt-2" label="รหัสธุรกรรม" v-model="qr_result.data.qrCodeData.order_id" type="text" readonly />
          <div v-if="qr_result.data.qrCodeData.qrType == 'crypto'" class="my-2">
            <vs-input class="w-full mt-2" label="ที่อยู่กระเป๋า (address)" :value="qr_result.data.qrCodeData.address" type="text" readonly />
            <vs-button size="small" color="primary" type="border" icon-pack="feather" icon="icon-copy" class="mt-2"
              @click="copyText(qr_result.data.qrCodeData.address)">
              คัดลอก address
            </vs-button>
            <vs-input class="w-full mt-2" label="เครือข่าย" :value="`${qr_result.data.qrCodeData.currency} ${qr_result.data.qrCodeData.chain}`" type="text" readonly />
            <vs-input class="w-full mt-2" label="จำนวนที่ลูกค้าต้องโอน" :value="`${qr_result.data.qrCodeData.amount_usdt} ${qr_result.data.qrCodeData.currency}`" type="text" readonly />
            <vs-input class="w-full mt-2" label="หมดอายุ" :value="qr_result.data.timeoutDate" type="text" readonly />
            <div v-if="qr_result.data.qrCodeData.qrImage" class="flex justify-center my-2">
              <img :src="qr_result.data.qrCodeData.qrImage" style="max-width: 220px; max-height: 220px;" />
            </div>
            <p class="mt-2 text-sm text-warning">
              ลูกค้าต้องโอนผ่านเครือข่าย {{ qr_result.data.qrCodeData.chain }} และโอนยอดให้ครบตามนี้เท่านั้น
            </p>
            <a v-if="qr_result.data.qrCodeData.paymentUrl" :href="qr_result.data.qrCodeData.paymentUrl" target="_blank">
              <vs-button color="success" size="small" icon-pack="feather" icon="icon-external-link" class="mt-2">
                ไปที่หน้าชำระเงิน
              </vs-button>
            </a>
          </div>
          <div v-else-if="qr_result.data.qrCodeData.qrType == 'img_url'" class="flex justify-center my-2">
            <img :src="qr_result.data.qrCodeData.qrCode" style="max-width: 220px; max-height: 220px;" />
          </div>
          <div v-else-if="qr_result.data.qrCodeData.qrType == 'redirect_url'" class="flex justify-center my-2">
            <a :href="qr_result.data.qrCodeData.qrCode" target="_blank">
              <vs-button color="success" size="small" icon-pack="feather" icon="icon-external-link" class="mt-2 ml-2">
                ไปที่หน้าชำระเงิน
              </vs-button>
            </a>
          </div>
          <div v-else>
            <vs-input class="w-full mt-2" label="เลขบัญชี" v-model="qr_result.data.qrCodeData.qrCode.bankAccount" type="text" readonly />
            <vs-input class="w-full mt-2" label="ชื่อบัญชี" v-model="qr_result.data.qrCodeData.qrCode.bankAccountName" type="text" readonly />
            <vs-input class="w-full mt-2" label="ธนาคาร" v-model="qr_result.data.qrCodeData.qrCode.bankName" type="text" readonly />
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'

import axios from '../../axios'
import moment from 'moment'
import store from '../../store/store'
import * as imageConversion from 'image-conversion'

export default {
  components: {
    vSelect,
    flatPickr,
    StatisticsCardLine
  },
  data () {
    return {
      date: moment.tz('Asia/Bangkok').format('YYYY-MM-DD'),
      amount: '',
      order_id: '',
      username: '',
      profile: {
        full_name: '',
        bank_number: '',
        sum_deposit: '',
        sum_withdraw: '',
        balance: '',
        bank_show: 0,
        bank_run: 0
      },
      popup_usebank: false,
      popup_cancel: false,
      popup_qr: false,
      config: {},
      memberData: [],
      status_usebank: [],
      selectedFile: [],
      chk_box: { text: 'กรุณาวางรูป', color: 'danger', data: false },
      deposit: 0,
      withdraw: 0,
      payment_code: '',
      qr_username: '',
      qr_amount: null,
      qr_result: null,
      is_crypto: false,
      coins: [],
      qr_currency_id: null,
      qr_crypto_amount: null
    }
  },
  computed: {
    selectedCoin () {
      return this.coins.find(coin => coin.id === this.qr_currency_id) || null
    },
    cryptoTHB () {
      const n = Number(this.qr_crypto_amount)
      if (!this.selectedCoin || !(n > 0)) return 0
      return Math.round(n * Number(this.selectedCoin.thb_rate) * 100) / 100
    },
    checkusebank () {
      if (this.$store.state.StatusBank.status === true) {
        this.selectdate()
        store.commit('SET_STATUS_USEBANK', false)
      }
      return ''
    }
  },
  watch: {
    async $route (to, from) {
      if (to.params.payment_code !== from.params.payment_code) {
        window.location.reload()
      }
    },
    date (newValue) {
      this.date = newValue
      this.selectdate()
    },
    selectedFile () {
      if (this.selectedFile.name.length > 0) {
        this.chk_box.text = 'วางรูปสำเร็จ'
        this.chk_box.color = 'success'
        this.chk_box.data = true
      } else {
        this.chk_box.text = 'วางรูปไม่สำเร็จ'
        this.chk_box.color = 'danger'
        this.chk_box.data = false
      }
    }
  },
  async mounted () {
    this.payment_code = this.$route.params.payment_code
    await this.selectdate()
    await this.getBalance()
    await this.getMeta()
  },
  methods: {
    async getBalance () {
      try {
        const { data } = await axios.post(
          `/super-payment/${this.payment_code}/api/balance`
        )

        let inner = null
        if (
          data.data &&
          typeof data.data === 'object' &&
          !Array.isArray(data.data)
        ) {
          inner = data.data
        }

        let walletInner = null
        const wr = data.originalResponse
        if (
          wr &&
          wr.success &&
          wr.data &&
          typeof wr.data === 'object'
        ) {
          walletInner = wr.data
        }

        const numOrNull = (v) => {
          if (v === undefined || v === null || v === '') return null
          const n = Number(v)
          return Number.isFinite(n) ? n : null
        }

        let depositVal = null
        let withdrawVal = null

        if (inner) {
          const b = numOrNull(inner.balance)
          const bw = numOrNull(inner.balance_withdraw)
          if (b !== null) depositVal = b
          if (bw !== null) withdrawVal = bw
        }

        if (walletInner) {
          const b = numOrNull(walletInner.balance)
          const bw = numOrNull(walletInner.balance_withdraw)
          const po = numOrNull(walletInner.pendingOut)
          if (depositVal === null && b !== null) depositVal = b
          if (withdrawVal === null && bw !== null) withdrawVal = bw
          if (withdrawVal === null && po !== null) withdrawVal = po
        }

        if (depositVal !== null || withdrawVal !== null) {
          if (depositVal !== null) this.deposit = depositVal
          if (withdrawVal !== null) this.withdraw = withdrawVal
          return
        }

        if (data.status && data.status.success && data.data) {
          const { balance, balance_withdraw } = data.data
          this.deposit = Number(balance) || 0
          this.withdraw = Number(balance_withdraw) || 0
        }
      } catch (e) {
        console.error(e)
      }
    },
    order_ref (row) {
      // หน้าประวัติฝาก-ถอน (และ BO) อ้างอิงด้วย internal_order_id ไม่ใช่ order_id ของ payment
      if (!row || typeof row !== 'object') return ''
      const internal = row.internal_order_id
      if (internal !== undefined && internal !== null && String(internal).trim() !== '') {
        return String(internal).trim()
      }
      return row.order_id
    },
    currency (amount) {
      // SET NULL OR NaN = 0
      if (amount === null || amount === undefined || amount === '' || amount === 'NaN') {
        amount = 0
      }
      const num = Number(amount)
      const n = Number.isFinite(num) ? num : 0
      const negative = n < 0
      const absStr = String(Math.abs(n))
      const parts = absStr.split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      const formatted = parts.length > 1 ? `${parts[0]}.${parts[1]}` : parts[0]
      return negative ? `-${formatted}` : formatted
    },
    check_status (status) {
      if (status === 0) {
        return 'รอการโอนเงิน'
      } else if (status === 1) {
        return 'ทำรายการสำเร็จ'
      } else if (status === 2) {
        return 'ไม่ทำรายการในเวลาที่กำหนด'
      } else if (status === 3) {
        return 'ยกเลิกการทำรายการ'
      } else if (status === 4) {
        return 'Payment ยกเลิกรายการ'
      } else if (status === 5) {
        return 'เลขบัญชีที่โอนไม่ตรงกับสมัคร'
      } else if (status === 99) {
        return 'Payment ทำรายการไม่สำเร็จ'
      }
    },
    check_status_addcredit (status) {
      if (status === 0) {
        return 'กำลังรอทำรายการ'
      } else if (status === 1) {
        return 'ทำรายการสำเร็จ'
      } else if (status === 2) {
        return 'ติดสถานะรับโบนัส'
      } else if (status === 3) {
        return 'หายูสเซอร์ไม่พบ'
      } else if (status === 4) {
        return 'ทำรายการผิดพลาด'
      } else if (status === 5) {
        return 'ติดสถานะยิงปลา'
      } else if (status === 6) {
        return 'ติดสถานะหวย'
      } else if (status === 7) {
        return 'มีรายการแทงค้างอยู่'
      } else if (status === 8) {
        return 'ติดสถานะอั้นถอน'
      } else if (status === 9) {
        return 'ทำรายการ UFA ไม่สำเร็จ'
      } else if (status === 98) {
        return 'ยกเลิกรายการฝาก'
      } else {
        return '-'
      }
    },

    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    
    async selectdate () {
      await axios
        .get(`/super-payment/${this.payment_code}/list/${this.date}`)
        .then(response => (this.memberData = response.data))
    },
    input_username (order_id, amount) {
      this.username = ''
      this.order_id = order_id
      this.amount = amount
      this.popup_usebank = true
    },
    async use_bank (order_id, amount) {
      this.popup_usebank = false
      if (this.selectedFile.size > 0) {
        await axios
          .post(`/super-payment/${this.payment_code}/usepayment`, {
            username: this.username,
            order_id,
            amount
          })
          .then(response => (this.status_usebank = response.data))
        await this.onUploadFile()
        this.$vs.notify({
          time: this.status_usebank.status === true ? 3000 : 8000,
          color: this.status_usebank.status === true ? 'success' : 'danger',
          position: 'top-right',
          icon: this.status_usebank.status === true ? 'check_box' : 'error',
          title: this.status_usebank.status === true ? 'ใช้ยอดสำเร็จ' : 'ใช้ยอดไม่สำเร็จ',
          text: this.status_usebank.status === true ? `${this.status_usebank.info}` : `${this.status_usebank.info}`
        })
        if (this.status_usebank.status === true) {
          await axios.post('/line/bank', {
            username: this.username,
            balance: amount,
            admin: this.$store.state.AppActiveUser.username
          })
          setTimeout(() => {
            window.location.reload()
          }, 1500)
          await store.commit('SET_STATUS_USEBANK', true)
        }
      } else {
        this.$vs.notify({
          time: 10000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          title: 'ทำรายการไม่สำเร็จ',
          text: 'กรุณาอัพสลิปหรือภาพที่เกี่ยวข้องกับการเพิ่มเครดิต'
        })
      }
    },
    input_cancel (order_id, amount) {
      this.username = ''
      this.order_id = order_id
      this.amount = amount
      this.popup_cancel = true
    },
    async use_cancel (order_id) {
      this.popup_cancel = false
      await axios
        .post(`/super-payment/${this.payment_code}/canceldeposit`, {
          bank: `${this.payment_code}_payment`,
          username: this.username,
          order_id
        })
        .then(response => (this.status_usecancel = response.data))
      this.$vs.notify({
        time: this.status_usecancel.status === true ? 3000 : 8000,
        color: this.status_usecancel.status === true ? 'success' : 'danger',
        position: 'top-right',
        icon: this.status_usecancel.status === true ? 'check_box' : 'error',
        title:
          this.status_usecancel.status === true ? 'ใช้ยอดสำเร็จ' : 'ใช้ยอดไม่สำเร็จ',
        text: this.status_usecancel.status === true ? `${this.status_usecancel.info}` : `${this.status_usecancel.info}`
      })

      await store.commit('SET_STATUS_USEBANK', true)
    },
    onFileChange (e) {
      const selectedFile = e.target.files[0]
      this.selectedFile = selectedFile
    },
    async compressFile () {
      const res = await imageConversion.compress(this.selectedFile, {
        size: 100,
        quality: 0.5,
        type: 'image/jpg'
        // width: 300,
        // height: 200,
        // scale: 0.5
      })
      this.selectedFile = res
    },
    async onUploadFile () {
      await this.compressFile()
      const formData = new FormData()
      formData.append('path', 'payment')
      formData.append('file', this.selectedFile)
      formData.append('topupid', this.order_id) // appending file

      // sending file to the backend
      const respone = await axios
        .post('/aws3/upload/upload', formData)
        .then()
      // .catch(err => { console.log('errja', err) })
      //   console.log(respone)
      if (respone.status === 200 && respone.data) {
        this.$vs.notify({
          time: 10000,
          color: 'success',
          position: 'top-right',
          icon: 'error',
          title: 'อัพโหลดรูปสำเร็จ',
          text: 'อัพโหลดรูปสำเร็จ'
        })
      }
    },
    retrieveImageFromClipboardAsBlob (pasteEvent, callback) {
      if (pasteEvent.clipboardData === false) {
        if (typeof callback === 'function') {
          callback(undefined)
        }
      }

      const items = pasteEvent.clipboardData.items

      if (items === undefined) {
        if (typeof callback === 'function') {
          callback(undefined)
        }
      }

      for (let i = 0; i < items.length; i++) {
        // Skip content if not image
        if (items[i].type.indexOf('image') === -1) continue
        // Retrieve image on clipboard as blob
        const blob = items[i].getAsFile()

        if (typeof callback === 'function') {
          callback(blob)
          this.selectedFile = blob
        }
      }
    },
    onPaste (evt) {
      // console.log('on paste', evt)
      // Handle the event
      this.retrieveImageFromClipboardAsBlob(evt, function (imageBlob) {
        // If there's an image, display it in the canvas
        if (imageBlob) {
          const canvas = document.getElementById('mycanvas')
          const ctx = canvas.getContext('2d')

          // Create an image to render the blob on the canvas
          const img = new Image()

          // Once the image loads, render the img on the canvas
          img.onload = function () {
            // Update dimensions of the canvas with the dimensions of the image


            // Draw the resized image
            const resizedWidth = 300 // Adjust the resized width as needed
            const resizedHeight = (img.height / img.width) * resizedWidth

            canvas.width = resizedWidth
            canvas.height = resizedHeight

            ctx.drawImage(img, 0, 0, resizedWidth, resizedHeight)
            // Draw the image


            // Display a smaller version of the image
            const thumbnailCanvas = document.getElementById('thumbnailCanvas')
            const thumbnailCtx = thumbnailCanvas.getContext('2d')

            const thumbnailSize = 100 // Adjust the size as needed
            thumbnailCanvas.width = thumbnailSize
            thumbnailCanvas.height = thumbnailSize
            thumbnailCtx.drawImage(img, 0, 0, img.width, img.height, 0, 0, thumbnailSize, thumbnailSize)
          }

          // Crossbrowser support for URL
          const URLObj = window.URL || window.webkitURL

          // Creates a DOMString containing a URL representing the object given in the parameter
          // namely the original Blob
          img.src = URLObj.createObjectURL(imageBlob)
        }
      })
    },
    async getMeta () {
      try {
        const { data } = await axios.get(`/super-payment/${this.payment_code}/meta`)
        this.is_crypto = data.is_crypto === true
        this.coins = Array.isArray(data.coins) ? data.coins : []
      } catch (e) {
        console.error(e)
      }
    },
    async generateCrypto () {
      // ไม่มี default เครือข่ายโดยเจตนา — ออก address ผิดเชน ลูกค้าโอนแล้วเงินหาย
      if (!this.qr_username || !this.qr_currency_id || !(Number(this.qr_crypto_amount) > 0)) {
        this.$vs.notify({
          time: 8000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          title: 'ข้อมูลไม่ครบ',
          text: 'กรุณากรอก username เลือกเหรียญ / เครือข่าย และจำนวนเหรียญ'
        })
        return
      }
      const result = (await axios.post(`/super-payment/${this.payment_code}/generate`, {
        username: this.qr_username,
        currency_id: this.qr_currency_id,
        crypto_amount: this.qr_crypto_amount
      })).data
      this.$vs.notify({
        time: 10000,
        color: result.success ? 'success' : 'danger',
        position: 'top-right',
        icon: result.success ? 'check' : 'error',
        title: result.code,
        text: result.message
      })
      if (!result.success) return
      this.qr_result = result
      this.qr_crypto_amount = null
      this.qr_username = null
      await this.selectdate()
    },
    copyText (text) {
      navigator.clipboard.writeText(String(text || '')).then(() => {
        this.$vs.notify({ time: 2000, color: 'success', position: 'top-right', icon: 'check', title: 'คัดลอกแล้ว', text })
      }).catch(() => {})
    },
    async generateQR (paymentMethod = 'qr') {
      if (this.is_crypto) return this.generateCrypto()
      if (!this.qr_username || !this.qr_amount) return
      const result = (await axios.post(`/super-payment/${this.payment_code}/generate`, {
        amount: this.qr_amount,
        username: this.qr_username,
        paymentMethod
      })).data
      if (!result.success) {
        this.$vs.notify({
          time: 10000,
          color: 'danger',
          position: 'top-right',
          icon: 'error',
          title: result.code,
          text: result.message
        })
        return
      }
      this.$vs.notify({
        time: 10000,
        color: 'success',
        position: 'top-right',
        icon: 'check',
        title: result.code,
        text: result.message
      })
      this.qr_result = result
      this.qr_amount = null
      this.qr_username = null
    }
  }
}
</script>
